import geojs from './_geojs';
import ipapi from './_ipapi';

export default {
  geojs,
  ipapi
}